// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__PsKDq","title":"FrontImage_title__C3BwZ"};